import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IWhistleBlowEventLogListItem, WhistleBlowEventLogListItem } from "./whistleBlowEventLogListItem";

export interface IWhistleBlowEventLogListItems extends ListItems<IWhistleBlowEventLogListItem> {
}

export class WhistleBlowEventLogListItems extends ListItems<WhistleBlowEventLogListItem> implements IWhistleBlowEventLogListItems {
    constructor();
    constructor(obj: IWhistleBlowEventLogListItem);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, WhistleBlowEventLogListItem);
    }
}